import React from 'react';
import type { GlobalThreatGroupAnalysisResult } from '@types';
import { Section } from './ReportShared';
import AnalysisMarkdown from './AnalysisMarkdown';
import { httpSource } from '../../../functions/src/common/threatGroupTelemetry';

const ThreatGroupMission: React.FC<{ result: GlobalThreatGroupAnalysisResult }> = ({ result }) => (
    <>
        {result.clientQuestionAnswers?.map(answer => (
            <Section key={answer.questionIndex} id={`threat-group-kiq-${answer.questionIndex}`} title={`Client Question ${answer.questionIndex}: ${answer.question}`}>
                <AnalysisMarkdown value={answer.answer} className="text-sm text-slate-700" />
                <h3 className="mt-3 font-semibold">Operational implications</h3>
                <AnalysisMarkdown value={answer.operationalImpact} className="text-sm text-slate-700" />
                {!!answer.tripwires?.length && (
                    <div className="mt-4">
                        <h3 className="font-semibold">Evacuation Readiness Triggers</h3>
                        <p className="report-print-keep-with-next mb-2 text-xs text-slate-600">Proposed thresholds require client confirmation. These conditions define readiness changes; they do not state that a phase is currently active.</p>
                        <div className="overflow-x-auto">
                            <table className="threat-group-tripwires w-full border-collapse text-left text-xs">
                                <thead><tr>{['Phase', 'Observable tripwire', 'Confirmation window', 'Action', 'Decision owner', 'Threshold basis'].map(label => <th key={label}>{label}</th>)}</tr></thead>
                                <tbody>{answer.tripwires.map((row, index) => (
                                    <tr key={index}>
                                        <td className="font-semibold">{row.phase}</td>
                                        <td><strong>{row.signal}</strong><p>{row.threshold}</p><p>Scope: {row.scope}</p></td>
                                        <td>{row.window}</td>
                                        <td>{row.action}</td>
                                        <td>{row.owner}</td>
                                        <td>{row.basis === 'client_supplied' ? 'Client supplied' : 'Proposed; confirm with client'}</td>
                                    </tr>
                                ))}</tbody>
                            </table>
                        </div>
                    </div>
                )}
                {answer.evidenceGap && <div className="mt-3"><h3 className="font-semibold">Evidence & policy gaps</h3><AnalysisMarkdown value={answer.evidenceGap} className="text-sm text-slate-700" /></div>}
                {!!answer.sourceUrls?.filter(httpSource).length && <ul className="mt-3 flex flex-wrap gap-3 text-xs">{answer.sourceUrls.filter(httpSource).map((url, index) => <li key={url}><a href={url} target="_blank" rel="noopener noreferrer" className="underline">Supporting source {index + 1}</a></li>)}</ul>}
            </Section>
        ))}
    </>
);

export default ThreatGroupMission;
